import styles from "./TabLayout.module.scss";
import React from "react";

export const TabWithNavContent = ({children}) => {
    return <div className={styles['content']}>
        {children}
    </div>
}

export const TabWithNavContentContainer = ({children}) => {
    return <div className={styles['content-container']}>
        {children}
    </div>
}

export const TabWithNav = ({children}) => {
    return <div className={styles['tab-with-nav']}>
        {children}
    </div>
}
